import { FC } from "react";
import { StoreDescriptionWrapper } from "./store-description.styled";
import { DomunIcon } from "@dashboard/assets/icons";

export type StoreDescriptionTypes = {
  title: string;
  description: string;
};

const StoreDescription: FC<StoreDescriptionTypes> = ({
  title,
  description,
}) => {
  return (
    <StoreDescriptionWrapper>
      <DomunIcon svgColor="black" svgHeight={40} />
      <div className="title">{title}</div>
      <div className="description">{description}</div>
    </StoreDescriptionWrapper>
  );
};

export default StoreDescription;
